<template>
  <div class="profile">
    <page-header :title="$auth.user.name" icon="user">
      <div slot="sub-title">
        Profile management
      </div>
      <div slot="controls">
        <el-button type="primary" class="white-button" icon="el-icon-upload" @click="updateUser" :loading="loading" plain>Save</el-button>
      </div>
    </page-header>

    <div class="body-padding" v-if="!loaded">
      <el-card class="mobile-padding no-padding">
        <div style="height: 100vh;"></div>
      </el-card>
    </div>

    <el-row :gutter="20" class="body-padding">
      <el-col :lg="8" :md="12">
        <el-card class="mobile-padding no-padding">
          <user-details @change="setFormData" class="card-padding" v-if="loaded" :user="user" />
        </el-card>
      </el-col>
      <el-col :lg="8" :md="12">
        <el-card class="mobile-padding no-padding">
          <localization-details @change="setFormData" class="card-padding" v-if="loaded" :user="user" />
        </el-card>
      </el-col>
      <el-col :lg="8" :md="12">
        <el-card class="mobile-padding no-padding margin-top mobile-no-margin-bottom">
          <security-details :errors="errors" @change="setFormData" class="card-padding" v-if="loaded" />
          <transition name="fade">
            <el-alert v-if="showPasswordAlertSuccess" title="Your password have been changed" type="success" class="dg-alert"></el-alert>
          </transition>
        </el-card>
      </el-col>
    </el-row>

    <el-button type="primary" class="show-mobile mobile-save-button" icon="el-icon-upload">Save changes</el-button>
    <div><el-button type="info" class="show-mobile signout-button" icon="el-icon-caret-left" @click="signOut">Log out</el-button></div>
  </div>
</template>

<script>
import UserDetails from './UserDetails'
import LocalizationDetails from './LocalizationDetails'
import SecurityDetails from './SecurityDetails'

export default {
  name: 'Profile',
  components: { UserDetails, LocalizationDetails, SecurityDetails },
  data () {
    return {
      loaded: false,
      loading: false,
      formData: {},
      user: {},
      showPasswordAlertSuccess: false,
      errors: {
        confirmPassword: '',
        password: '',
        currenctPassword: ''
      }
    }
  },
  methods: {
    setFormData (data) {
      for (let k in data) {
        this.formData[k] = data[k]
      }
    },
    clearErrors () {
      for (let k in this.errors) {
        this.errors[k] = ''
      }
    },
    passwordChangeSuccess () {
      this.showPasswordAlertSuccess = true
      this.formData.currentPassword = ''
      this.formData.password = ''
      this.formData.confirmPassword = ''
      setTimeout(() => {
        this.showPasswordAlertSuccess = false
      }, 1000)
    },
    async updateUser () {
      this.loading = true
      this.clearErrors()
      try
      {
        const response = await this.$http.put(this.$api.users.update(this.$auth.user.id), this.formData)
        this.$root.saldo = response.data.saldo
        this.$root.currency = response.data.currency.name
        this.$message.success('Your details have been updated')
        if (this.formData.currentPassword && this.formData.currentPassword !== '') {
          this.passwordChangeSuccess()
        }

        localStorage.removeItem('mapCenter')
      } catch (error) {
        for (let k in error.response.data) {
          this.errors[k] = error.response.data[k]
        }
      }

      this.loading = false
    },
    async getUser () {
      const response = await this.$http.get(this.$api.users.get(this.$auth.user.id))
      this.user = response.data
      this.loaded = true
    },
    signOut () {
      this.$auth.logout()
      setTimeout(() => {
        this.$router.push('/')
      }, 200)
    }
  },
  created () {
    this.getUser()
  }
}
</script>

<style lang="scss" scoped>
  .dg-alert {
    width: auto;
    margin: -40px 40px 20px 40px;
    box-sizing: border-box;
  }

  .card-padding {
    padding: 0px 40px 60px 40px;

    @include breakpoint (xs) {
      padding: 0px 20px 20px 20px;
    }
  }

  .margin-top {
    @include breakpoint (md-lg) {
      margin-top: 20px;
    }
  }

  .mobile-save-button {
    box-sizing: border-box;
    width: calc(100% - 40px);
    margin: 0px 20px;
    margin-bottom: 10px;
  }

  .signout-button {
    box-sizing: border-box;
    width: calc(100% - 40px);
    margin: 0px 20px;
    margin-bottom: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/profile/Profile.vue